import { useTranslation } from "react-i18next";
import { useTheme } from "@hooks/useTheme";
import UpdateSummaryContent from "@components/Dialogs/UpdateSummaryContent";

const UpdateSummaryModal = ({
  isOpen,
  onClose,
  updateSummary,
  "data-testid": dataTestId = "update-summary-modal",
}) => {
  const { colors = {} } = useTheme();
  const { t } = useTranslation();

  if (!isOpen || !updateSummary) return null;

  return (
    <div
      className={`fixed inset-0 ${colors.bgBlurModal} z-50 flex items-center justify-center backdrop-blur-[1px]`}
      data-testid={`${dataTestId}-overlay`}
    >
      <div
        className={`border ${colors.borderPrimary} ${colors.bgModal} min-h-[58vh] max-h-[80vh] w-[40rem] flex-shrink-0 flex flex-col rounded-lg shadow-xl`}
        data-testid={dataTestId}
      >
        <div className="flex-1 overflow-y-auto px-6 py-6" data-testid={`${dataTestId}-body`}>
          <UpdateSummaryContent updateSummary={updateSummary} data-testid={`${dataTestId}-summary`} />
        </div>

        <div className="px-6 py-6 flex-shrink-0 flex justify-end space-x-3" data-testid={`${dataTestId}-footer`}>
          <button
            type="button"
            data-testid={`${dataTestId}-close-button`}
            onClick={onClose}
            className={`rounded-lg px-4 py-2 h-10 text-sm font-medium border transition-colors ${colors.borderPrimary} ${colors.textPrimary} ${colors.hover}`}
          >
            {t("update-summary.close")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateSummaryModal;
